// import FCellDateTimeMDP from "@/components/generic/table/cell/FCellDateTimeMDP";
// import FCellPhoneMDP from "@/components/generic/table/cell/FCellPhoneMDP";

// import FDataTableMDP, {
//     ActionType,
// } from "@/components/generic/table/FDataTableMDP";
import * as Data from "@/../src-gen/data";
import FCellBtnMDP from "@/components/table/cell/FCellBtnMDP";
import FCellDateTimeMDP from "@/components/table/cell/FCellDateTimeMDP";
import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
// import FCellBtnMDP from "@/components/generic/table/cell/FCellBtnMDP";

export default class STRequestFDataTableMDP extends FDataTableMDP {
    parent: any;
    constructor(props: { parent: any }) {
        super({
            myRefName: "stRequestFDataTableRef",
            enableSearch: true,
            title: "Agent list",
            itemKey: "taskId",
            multiSelect: true,
        });
        this.parent = props.parent;

        this
            .addClientFileNumberColumn({ dataSelectorKey: "cid", hidden: true })
            .addClientNameColumn({
                dataSelectorKey: "displayId",
                paramKey: "taskInput.clRegistrationDetails.clientId",
                hidden: true
            })
            .addStatusColumn({
                label: "",
                dataSelectorKey: "priority",
                outlined: true,
                hidden: true
            })
            .addColumn({
                label: "Agent Mobile",
                dataSelectorKey: "taskInput.creditorMobile",
                columnCellMDP: new FCellBtnMDP({ onClick: () => {} }),
            })
            .addColumn({
                label: "Agent Name",
                dataSelectorKey: "taskInput.creditorName",
            })
            .addColumn({
                label: "Agency Name",
                dataSelectorKey: "taskInput.bankAgencyName",
            })
            .addClientFileStatusColumn({ label: "Status", dataSelectorKey: "taskState.name", })
            .addColumn({
                label: "Created Time",
                dataSelectorKey: "createdTime",
                columnCellMDP: new FCellDateTimeMDP(),
            })
            .addColumn({
                label: "allocated To",
                dataSelectorKey: "allocatedTo",
                enableGroupBy: true
            })

            .addColumn({
                label: "Allocated On",
                dataSelectorKey: "allocatedTime",
                columnCellMDP: new FCellDateTimeMDP(),
            })
            .addColumn({
                label: "Raised By",
                dataSelectorKey: "taskInput.raisedBy",
            })
            .addAction({
                type: ActionType.ADD,
                onClick: (item) => this.handleCreateSettlementRequestClick(item),
                label: "Create Settlement Request",
            })
            ;
    }

    handleCreateSettlementRequestClick(item: any) {
        return new Promise(resolve => {
            this.parent.handleCreateSettlementRequestClick();
        });
    }



}
